import XAPPService from 'app/Core/services/XAPPService';
import { showMessage } from 'app/store/actions';
import history from "history.js";
export const ATUALIZANDO_TENTAR_NOVAMENTE = "[ATUALIZANDO] TENTAR NOVAMENTE";
export const ATUALIZANDO_PROCESSANDO = "[ATUALIZANDO] PROCESSANDO";

export function NovoAmbiente(_AParams) {
    return (dispatch) => {
        dispatch({ type: ATUALIZANDO_PROCESSANDO, payload: true });
        const AUsuario = sessionStorage.getItem("username");

        const ARota = `/Register/novoambiente`;
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Usuario", AUsuario);
        myHeaders.append("Empresa", _AParams.empresa);
        fetch(ARota, {
            method: "get",
            headers: myHeaders,
        })
            .then(resp => {
                if (resp.status === 200) {
                    resp.json().then(response => {
                        if (!_.isNull(response.error)) {
                            dispatch(showMessage({ variant: "error", message: response.error }));
                            dispatch({ type: ATUALIZANDO_TENTAR_NOVAMENTE, payload: !response.error[0].includes("P0001: ") });
                        }
                        else {
                            dispatch(showMessage({ variant: "success", message: response.info }));
                            if (response.data === "2") {
                                history.push("/pub-login");
                            }
                            if (response.data === "1") {
                                setTimeout(() => history.push("/home"), 2000);
                            }
                        }
                    });
                }
                else {
                    dispatch(showMessage({ variant: "error", message: "Erro ao processar solicitação, informe o adminstrador do sistema." }));
                    dispatch({ type: ATUALIZANDO_TENTAR_NOVAMENTE, payload: true });
                }
            })
            .catch(error => {
                dispatch(showMessage({ variant: "error", message: "Erro ao processar solicitação, informe o adminstrador do sistema." }));
                dispatch({ type: ATUALIZANDO_TENTAR_NOVAMENTE, payload: true });
            });
    };
}
